export const getAdminLoadingState = state => state.admin.loading;
export default getAdminLoadingState;
